import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {ConversationEventContainerModel} from "../../../../../../../models/aggregates/alg/cc/conversation";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class ConversationEventService extends BaseApiTemplateService<ConversationEventContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation-events';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation-events';
    this.httpClient = http;
  }
}
